export enum DisputeReason {
  FRAUDULENT = "FRAUDULENT",
  NOT_RECEIVED = "NOT_RECEIVED",
  DUPLICATE_CHARGE = "DUPLICATE_CHARGE",
  NOT_AS_DESCRIBED = "NOT_AS_DESCRIBED",
  PREVIOUSLY_CANCELED = "PREVIOUSLY_CANCELED",
  OTHER = "OTHER",
}
